import { sumBy, find } from 'lodash';

export const preferredProduct = (products) => find(products, ({ isPreferred }) => isPreferred);

export const productSplitsValue = (product) =>
  sumBy(product?.productSplits, (split) => split.totalLoanAmount);

export const productSplitsValueWithLMI = (product) =>
  product?.productSplits[0]?.totalLoanAmountWithLmi;

export const value = (loan, country): number => {
  const product = preferredProduct(loan);
  return country === 'AU'
    ? productSplitsValueWithLMI(product) || productSplitsValue(product)
    : productSplitsValue(product);
};

export default {
  preferredProduct,
  productSplitsValue,
  productSplitsValueWithLMI,
  value
};
